// extracted by mini-css-extract-plugin
export default {"container":"Pxdp1Spak1NVvw61_UJh"};